/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.sendMessage'

export { $nsid }

const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    convoId: l.string(),
    message: l.ref<ConvoDefs.MessageInput>(
      (() => ConvoDefs.messageInput) as any,
    ),
  }),
  l.payload(
    'application/json',
    l.ref<ConvoDefs.MessageView>((() => ConvoDefs.messageView) as any),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
